// extracted by mini-css-extract-plugin
module.exports = {"help-button":"help_chat_help-button__MU438","help-button-bubble":"help_chat_help-button-bubble__FZqxA","help-button-wrapper":"help_chat_help-button-wrapper__f5QP8"};